import { SET_ITEMS } from '../actions/types';

export default function items(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_ITEMS:
				return action.payload;

			// no default
		}
	}

	return state;
}
